import React, { useEffect } from "react";
import "./component.css";
import { Box } from "@mui/material";
import { useTheme } from "@emotion/react";
import Lottie from "lottie-react";
import animationData from "../decoration.json";
import Nav from "./nav/Navo";
import Aos from "aos";
const Intro = ({ setmymode, textinline, mode }) => {
  useEffect(() => {
    Aos.init({ duration: 500 });
  }, []);
  const theme = useTheme();
  return (
    <div style={{
  overflowX: 'hidden',

    }} >
      <Box
        className="parent-box"
        sx={{ color: theme.palette.mode === "dark" ? "black" : "white" }}
        data-stellar-background-ratio="0.5"
      >
        <Nav setmymode={setmymode} mode={mode} />
        <div className="hero-slant">
          <Box className="skewy" />
          <div>
            {" "}
            <Lottie
              data-aos="fade-up"
              className="lotti1"
              animationData={animationData}
            />
          </div>
          <div>
            {" "}
            <Lottie
              data-aos="fade-up"
              className="lotti2"
              animationData={animationData}
            />
          </div>
          <div></div>
        </div>
      </Box>
      <div className="containerintro">
        <div>
          <div className="introcenter">
            <h1 data-aos='zoom-out'>
              {textinline.headh1 + " "}
              <span className="cursor" style={{ color: "#e84545" }}>{textinline.spano}</span>
              <sub>{textinline.subh1}</sub>
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Intro;
